var items = {
  "block.minecraft.air": "aire",
  "block.minecraft.stone": "roca",
  "block.minecraft.granite": "granit",
  "block.minecraft.polished_granite": "granit polit",
  "block.minecraft.diorite": "diorita",
  "block.minecraft.polished_diorite": "diorita polida",
  "block.minecraft.andesite": "andesita",
  "block.minecraft.polished_andesite": "andesita polida",
  "block.minecraft.grass_block": "bloc d'herba",
  "block.minecraft.dirt": "terra",
  "block.minecraft.coarse_dirt": "terra seca",
  "block.minecraft.podzol": "pinassa",
  "block.minecraft.crimson_nylium": "netheli carmesí",
  "block.minecraft.warped_nylium": "netheli guerxo",
  "block.minecraft.cobblestone": "pedra",
  "block.minecraft.oak_planks": "fusta de pomer",
  "block.minecraft.spruce_planks": "fusta de pi",
  "block.minecraft.birch_planks": "fusta de bedoll",
  "block.minecraft.jungle_planks": "fusta de jungla",
  "block.minecraft.acacia_planks": "fusta d'acàcia",
  "block.minecraft.dark_oak_planks": "fusta de pomer fosc",
  "block.minecraft.crimson_planks": "fusta carmesina",
  "block.minecraft.warped_planks": "fusta guerxa",
  "block.minecraft.oak_sapling": "esqueix de pomer",
  "block.minecraft.spruce_sapling": "esqueix de pi",
  "block.minecraft.birch_sapling": "esqueix de bedoll",
  "block.minecraft.jungle_sapling": "esqueix de jungla",
  "block.minecraft.acacia_sapling": "esqueix d'acàcia",
  "block.minecraft.dark_oak_sapling": "esqueix de pomer fosc",
  "block.minecraft.bedrock": "roca base",
  "block.minecraft.sand": "sorra",
  "block.minecraft.red_sand": "sorra vermella",
  "block.minecraft.gravel": "grava",
  "block.minecraft.gold_ore": "mena d'or",
  "block.minecraft.iron_ore": "mena de ferro",
  "block.minecraft.coal_ore": "mena de carbó",
  "block.minecraft.nether_gold_ore": "mena d'or del nether",
  "block.minecraft.oak_log": "tronc de pomer",
  "block.minecraft.spruce_log": "tronc de pi",
  "block.minecraft.birch_log": "tronc de bedoll",
  "block.minecraft.jungle_log": "tronc de jungla",
  "block.minecraft.acacia_log": "tronc d'acàcia",
  "block.minecraft.dark_oak_log": "tronc de pomer fosc",
  "block.minecraft.crimson_stem": "peu carmesí",
  "block.minecraft.warped_stem": "peu guerxo",
  "block.minecraft.stripped_oak_log": "tronc de pomer escorçat",
  "block.minecraft.stripped_spruce_log": "tronc de pi escorçat",
  "block.minecraft.stripped_birch_log": "tronc de bedoll escorçat",
  "block.minecraft.stripped_jungle_log": "tronc de jungla escorçat",
  "block.minecraft.stripped_acacia_log": "tronc d'acàcia escorçat",
  "block.minecraft.stripped_dark_oak_log": "tronc de pomer fosc escorçat",
  "block.minecraft.stripped_crimson_stem": "peu carmesí escorçat",
  "block.minecraft.stripped_warped_stem": "peu guerxo escorçat",
  "block.minecraft.stripped_oak_wood": "fusta de pomer escorçada",
  "block.minecraft.stripped_spruce_wood": "fusta de pi escorçada",
  "block.minecraft.stripped_birch_wood": "fusta de bedoll escorçada",
  "block.minecraft.stripped_jungle_wood": "fusta de jungla escorçada",
  "block.minecraft.stripped_acacia_wood": "fusta d'acàcia escorçada",
  "block.minecraft.stripped_dark_oak_wood": "fusta de pomer fosc escorçada",
  "block.minecraft.stripped_crimson_hyphae": "hifes carmesines escorçades",
  "block.minecraft.stripped_warped_hyphae": "hifes guerxes escorçades",
  "block.minecraft.oak_wood": "fusta de pomer",
  "block.minecraft.spruce_wood": "fusta de pi",
  "block.minecraft.birch_wood": "fusta de bedoll",
  "block.minecraft.jungle_wood": "fusta de jungla",
  "block.minecraft.acacia_wood": "fusta d'acàcia",
  "block.minecraft.dark_oak_wood": "fusta de pomer fosc",
  "block.minecraft.crimson_hyphae": "hifes carmesines",
  "block.minecraft.warped_hyphae": "hifes guerxes",
  "block.minecraft.oak_leaves": "fulles de pomer",
  "block.minecraft.spruce_leaves": "fulles de pi",
  "block.minecraft.birch_leaves": "fulles de bedoll",
  "block.minecraft.jungle_leaves": "fulles de jungla",
  "block.minecraft.acacia_leaves": "fulles d'acàcia",
  "block.minecraft.dark_oak_leaves": "fulles de pomer fosc",
  "block.minecraft.sponge": "esponja",
  "block.minecraft.wet_sponge": "esponja humida",
  "block.minecraft.glass": "vidre",
  "block.minecraft.lapis_ore": "mena de lapislàtzuli",
  "block.minecraft.lapis_block": "bloc de lapislàtzuli",
  "block.minecraft.dispenser": "dispensador",
  "block.minecraft.sandstone": "roca sorrenca",
  "block.minecraft.chiseled_sandstone": "roca sorrenca cisellada",
  "block.minecraft.cut_sandstone": "roca sorrenca tallada",
  "block.minecraft.note_block": "bloc musical",
  "block.minecraft.powered_rail": "rail propulsor",
  "block.minecraft.detector_rail": "rail detector",
  "block.minecraft.sticky_piston": "pistó enganxós",
  "block.minecraft.cobweb": "teranyina",
  "block.minecraft.grass": "herba",
  "block.minecraft.fern": "falguera",
  "block.minecraft.dead_bush": "arbust mort",
  "block.minecraft.seagrass": "herba marina",
  "block.minecraft.sea_pickle": "cogombre de mar",
  "block.minecraft.piston": "pistó",
  "block.minecraft.white_wool": "llana blanca",
  "block.minecraft.orange_wool": "llana taronja",
  "block.minecraft.magenta_wool": "llana magenta",
  "block.minecraft.light_blue_wool": "llana blau cel",
  "block.minecraft.yellow_wool": "llana groga",
  "block.minecraft.lime_wool": "llana llima",
  "block.minecraft.pink_wool": "llana rosa",
  "block.minecraft.gray_wool": "llana grisa",
  "block.minecraft.light_gray_wool": "llana gris clar",
  "block.minecraft.cyan_wool": "llana cian",
  "block.minecraft.purple_wool": "llana lila",
  "block.minecraft.blue_wool": "llana blava",
  "block.minecraft.brown_wool": "llana marró",
  "block.minecraft.green_wool": "llana verda",
  "block.minecraft.red_wool": "llana vermella",
  "block.minecraft.black_wool": "llana negra",
  "block.minecraft.dandelion": "dent de lleó",
  "block.minecraft.poppy": "rosella",
  "block.minecraft.blue_orchid": "orquídia blava",
  "block.minecraft.allium": "all bord",
  "block.minecraft.azure_bluet": "houstonia caerulea",
  "block.minecraft.red_tulip": "tulipa vermella",
  "block.minecraft.orange_tulip": "tulipa taronja",
  "block.minecraft.white_tulip": "tulipa blanca",
  "block.minecraft.pink_tulip": "tulipa rosa",
  "block.minecraft.oxeye_daisy": "margarida",
  "block.minecraft.cornflower": "blavet",
  "block.minecraft.lily_of_the_valley": "lliri de maig",
  "block.minecraft.wither_rose": "rosa de wither",
  "block.minecraft.brown_mushroom": "bolet marró",
  "block.minecraft.red_mushroom": "bolet vermell",
  "block.minecraft.crimson_fungus": "fong carmesí",
  "block.minecraft.warped_fungus": "fong guerxo",
  "block.minecraft.crimson_roots": "arrels carmesines",
  "block.minecraft.warped_roots": "arrels guerxes",
  "block.minecraft.nether_sprouts": "brots del nether",
  "block.minecraft.weeping_vines": "lianes ploroses",
  "block.minecraft.twisting_vines": "lianes retorçades",
  "block.minecraft.sugar_cane": "canya de sucre",
  "block.minecraft.kelp": "alga",
  "block.minecraft.bamboo": "bambú",
  "block.minecraft.gold_block": "bloc d'or",
  "block.minecraft.iron_block": "bloc de ferro",
  "block.minecraft.oak_slab": "llosa de pomer",
  "block.minecraft.spruce_slab": "llosa de pi",
  "block.minecraft.birch_slab": "llosa de bedoll",
  "block.minecraft.jungle_slab": "llosa de jungla",
  "block.minecraft.acacia_slab": "llosa d'acàcia",
  "block.minecraft.dark_oak_slab": "llosa de pomer fosc",
  "block.minecraft.crimson_slab": "llosa carmesina",
  "block.minecraft.warped_slab": "llosa guerxa",
  "block.minecraft.stone_slab": "llosa de roca",
  "block.minecraft.smooth_stone_slab": "llosa de roca llisa",
  "block.minecraft.sandstone_slab": "llosa de roca sorrenca",
  "block.minecraft.cut_sandstone_slab": "llosa de roca sorrenca tallada",
  "block.minecraft.petrified_oak_slab": "llosa de pomer petrificada",
  "block.minecraft.cobblestone_slab": "llosa de pedra",
  "block.minecraft.brick_slab": "llosa de maó",
  "block.minecraft.stone_brick_slab": "llosa de maons de roca",
  "block.minecraft.nether_brick_slab": "llosa de maons del nether",
  "block.minecraft.quartz_slab": "llosa de quars",
  "block.minecraft.red_sandstone_slab": "llosa de roca sorrenca vermella",
  "block.minecraft.cut_red_sandstone_slab": "llosa de roca sorrenca vermella tallada",
  "block.minecraft.purpur_slab": "llosa de purpur",
  "block.minecraft.prismarine_slab": "llosa de prismarina",
  "block.minecraft.prismarine_brick_slab": "llosa de maons de prismarina",
  "block.minecraft.dark_prismarine_slab": "llosa de prismarina fosca",
  "block.minecraft.smooth_quartz": "bloc de quars llis",
  "block.minecraft.smooth_red_sandstone": "roca sorrenca llisa",
  "block.minecraft.smooth_sandstone": "roca sorrenca llisa",
  "block.minecraft.smooth_stone": "roca llisa",
  "block.minecraft.bricks": "maons",
  "block.minecraft.tnt": "dinamita",
  "block.minecraft.bookshelf": "llibreria",
  "block.minecraft.mossy_cobblestone": "pedra amb molsa",
  "block.minecraft.obsidian": "obsidiana",
  "block.minecraft.torch": "torxa",
  "block.minecraft.end_rod": "bastó d'ender",
  "block.minecraft.chorus_plant": "planta de tornada",
  "block.minecraft.chorus_flower": "flor de tornada",
  "block.minecraft.purpur_block": "bloc de purpur",
  "block.minecraft.purpur_pillar": "pilar de purpur",
  "block.minecraft.purpur_stairs": "escales de purpur",
  "block.minecraft.spawner": "generador",
  "block.minecraft.oak_stairs": "escales de pomer",
  "block.minecraft.chest": "cofre",
  "block.minecraft.diamond_ore": "mena de diamant",
  "block.minecraft.diamond_block": "bloc de diamant",
  "block.minecraft.crafting_table": "taula d'elaboració",
  "block.minecraft.farmland": "terra de cultiu",
  "block.minecraft.furnace": "forn",
  "block.minecraft.ladder": "escala",
  "block.minecraft.rail": "rail",
  "block.minecraft.cobblestone_stairs": "escales de pedra",
  "block.minecraft.lever": "palanca",
  "block.minecraft.stone_pressure_plate": "placa de pressió de roca",
  "block.minecraft.oak_pressure_plate": "placa de pressió de pomer",
  "block.minecraft.spruce_pressure_plate": "placa de pressió de pi",
  "block.minecraft.birch_pressure_plate": "placa de pressió de bedoll",
  "block.minecraft.jungle_pressure_plate": "placa de pressió de jungla",
  "block.minecraft.acacia_pressure_plate": "placa de pressió d'acàcia",
  "block.minecraft.dark_oak_pressure_plate": "placa de pressió de pomer fosc",
  "block.minecraft.crimson_pressure_plate": "placa de pressió carmesina",
  "block.minecraft.warped_pressure_plate": "placa de pressió guerxa",
  "block.minecraft.polished_blackstone_pressure_plate": "placa de pressió de roca negra polida",
  "block.minecraft.redstone_ore": "mena de redstone",
  "block.minecraft.redstone_torch": "torxa de redstone",
  "block.minecraft.snow": "neu",
  "block.minecraft.ice": "gel",
  "block.minecraft.snow_block": "bloc de neu",
  "block.minecraft.cactus": "cactus",
  "block.minecraft.clay": "argila",
  "block.minecraft.jukebox": "tocadiscs",
  "block.minecraft.oak_fence": "tanca de pomer",
  "block.minecraft.spruce_fence": "tanca de pi",
  "block.minecraft.birch_fence": "tanca de bedoll",
  "block.minecraft.jungle_fence": "tanca de jungla",
  "block.minecraft.acacia_fence": "tanca d'acàcia",
  "block.minecraft.dark_oak_fence": "tanca de pomer fosc",
  "block.minecraft.crimson_fence": "tanca carmesina",
  "block.minecraft.warped_fence": "tanca guerxa",
  "block.minecraft.pumpkin": "carbassa",
  "block.minecraft.carved_pumpkin": "carbassa tallada",
  "block.minecraft.netherrack": "roca del nether",
  "block.minecraft.soul_sand": "sorra d'ànimes",
  "block.minecraft.soul_soil": "sòl d'ànimes",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "basalt polit",
  "block.minecraft.soul_torch": "torxa d'ànimes",
  "block.minecraft.glowstone": "roca brillant",
  "block.minecraft.jack_o_lantern": "carbassa de halloween",
  "block.minecraft.oak_trapdoor": "trapa de pomer",
  "block.minecraft.spruce_trapdoor": "trapa de pi",
  "block.minecraft.birch_trapdoor": "trapa de bedoll",
  "block.minecraft.jungle_trapdoor": "trapa de jungla",
  "block.minecraft.acacia_trapdoor": "trapa d'acàcia",
  "block.minecraft.dark_oak_trapdoor": "trapa de pomer fosc",
  "block.minecraft.crimson_trapdoor": "trapa carmesina",
  "block.minecraft.warped_trapdoor": "trapa guerxa",
  "block.minecraft.infested_stone": "roca infestada",
  "block.minecraft.infested_cobblestone": "pedra infestada",
  "block.minecraft.infested_stone_bricks": "maons de roca infestats",
  "block.minecraft.infested_mossy_stone_bricks": "maons de roca amb molsa infestats",
  "block.minecraft.infested_cracked_stone_bricks": "maons de roca esquerdats infestats",
  "block.minecraft.infested_chiseled_stone_bricks": "maons de roca cisellats infestats",
  "block.minecraft.stone_bricks": "maons de roca",
  "block.minecraft.mossy_stone_bricks": "maons de roca amb molsa",
  "block.minecraft.cracked_stone_bricks": "maons de roca esquerdats",
  "block.minecraft.chiseled_stone_bricks": "maons de roca cisellats",
  "block.minecraft.brown_mushroom_block": "bloc de bolet marró",
  "block.minecraft.red_mushroom_block": "bloc de bolet vermell",
  "block.minecraft.mushroom_stem": "peu de bolet",
  "block.minecraft.iron_bars": "barrots de ferro",
  "block.minecraft.chain": "cadena",
  "block.minecraft.glass_pane": "panell de vidre",
  "block.minecraft.melon": "síndria",
  "block.minecraft.vine": "lianes",
  "block.minecraft.oak_fence_gate": "porta de tanca de pomer",
  "block.minecraft.spruce_fence_gate": "porta de tanca de pi",
  "block.minecraft.birch_fence_gate": "porta de tanca de bedoll",
  "block.minecraft.jungle_fence_gate": "porta de tanca de jungla",
  "block.minecraft.acacia_fence_gate": "porta de tanca d'acàcia",
  "block.minecraft.dark_oak_fence_gate": "porta de tanca de pomer fosc",
  "block.minecraft.crimson_fence_gate": "porta de tanca carmesina",
  "block.minecraft.warped_fence_gate": "porta de tanca guerxa",
  "block.minecraft.brick_stairs": "escales de maó",
  "block.minecraft.stone_brick_stairs": "escales de maons de roca",
  "block.minecraft.mycelium": "miceli",
  "block.minecraft.lily_pad": "nenúfar",
  "block.minecraft.nether_bricks": "maons del nether",
  "block.minecraft.cracked_nether_bricks": "maons del nether esquerdats",
  "block.minecraft.chiseled_nether_bricks": "maons del nether cisellats",
  "block.minecraft.nether_brick_fence": "tanca de maó del nether",
  "block.minecraft.nether_brick_stairs": "escales de maons del nether",
  "block.minecraft.enchanting_table": "taula d'encanteris",
  "block.minecraft.end_portal_frame": "marc del portal d'ender",
  "block.minecraft.end_stone": "roca d'ender",
  "block.minecraft.end_stone_bricks": "maons de roca d'ender",
  "block.minecraft.dragon_egg": "ou de drac",
  "block.minecraft.redstone_lamp": "làmpada de redstone",
  "block.minecraft.sandstone_stairs": "escales de roca sorrenca",
  "block.minecraft.emerald_ore": "mena de maragda",
  "block.minecraft.ender_chest": "cofre d'ender",
  "block.minecraft.tripwire_hook": "ganxo",
  "block.minecraft.emerald_block": "bloc de maragda",
  "block.minecraft.spruce_stairs": "escales de pi",
  "block.minecraft.birch_stairs": "escales de bedoll",
  "block.minecraft.jungle_stairs": "escales de jungla",
  "block.minecraft.crimson_stairs": "escales carmesines",
  "block.minecraft.warped_stairs": "escales guerxes",
  "block.minecraft.command_block": "bloc de comandaments",
  "block.minecraft.beacon": "far",
  "block.minecraft.cobblestone_wall": "mur de pedra",
  "block.minecraft.mossy_cobblestone_wall": "mur de pedra amb molsa",
  "block.minecraft.brick_wall": "mur de maó",
  "block.minecraft.prismarine_wall": "mur de prismarina",
  "block.minecraft.red_sandstone_wall": "mur de roca sorrenca vermella",
  "block.minecraft.mossy_stone_brick_wall": "mur de maons de roca amb molsa",
  "block.minecraft.granite_wall": "mur de granit",
  "block.minecraft.stone_brick_wall": "mur de maons de roca",
  "block.minecraft.nether_brick_wall": "mur de maons del nether",
  "block.minecraft.andesite_wall": "mur d'andesita",
  "block.minecraft.red_nether_brick_wall": "mur de maons del nether vermells",
  "block.minecraft.sandstone_wall": "mur de roca sorrenca",
  "block.minecraft.end_stone_brick_wall": "mur de maons de roca d'ender",
  "block.minecraft.diorite_wall": "mur de diorita",
  "block.minecraft.blackstone_wall": "mur de roca negra",
  "block.minecraft.polished_blackstone_wall": "mur de roca negra polida",
  "block.minecraft.polished_blackstone_brick_wall": "mur de maons de roca negra polida",
  "block.minecraft.stone_button": "botó de roca",
  "block.minecraft.oak_button": "botó de pomer",
  "block.minecraft.spruce_button": "botó de pi",
  "block.minecraft.birch_button": "botó de bedoll",
  "block.minecraft.jungle_button": "botó de jungla",
  "block.minecraft.acacia_button": "botó d'acàcia",
  "block.minecraft.dark_oak_button": "botó de pomer fosc",
  "block.minecraft.crimson_button": "botó carmesí",
  "block.minecraft.warped_button": "botó guerxo",
  "block.minecraft.polished_blackstone_button": "botó de roca negra polida",
  "block.minecraft.anvil": "enclusa",
  "block.minecraft.chipped_anvil": "enclusa danyada",
  "block.minecraft.damaged_anvil": "enclusa molt danyada",
  "block.minecraft.trapped_chest": "cofre trampa",
  "block.minecraft.light_weighted_pressure_plate": "placa de pressió per a pes lleuger",
  "block.minecraft.heavy_weighted_pressure_plate": "placa de pressió per a pes elevat",
  "block.minecraft.daylight_detector": "sensor de llum solar",
  "block.minecraft.redstone_block": "bloc de redstone",
  "block.minecraft.nether_quartz_ore": "mena de quars del nether",
  "block.minecraft.hopper": "tremuja",
  "block.minecraft.chiseled_quartz_block": "bloc de quars cisellat",
  "block.minecraft.quartz_block": "bloc de quars",
  "block.minecraft.quartz_bricks": "maons de quars",
  "block.minecraft.quartz_pillar": "pilar de quars",
  "block.minecraft.quartz_stairs": "escales de quars",
  "block.minecraft.activator_rail": "rail activador",
  "block.minecraft.dropper": "subministrador",
  "block.minecraft.white_terracotta": "terracota blanca",
  "block.minecraft.orange_terracotta": "terracota taronja",
  "block.minecraft.magenta_terracotta": "terracota magenta",
  "block.minecraft.light_blue_terracotta": "terracota blau cel",
  "block.minecraft.yellow_terracotta": "terracota groga",
  "block.minecraft.lime_terracotta": "terracota verd llima",
  "block.minecraft.pink_terracotta": "terracota rosa",
  "block.minecraft.gray_terracotta": "terracota grisa",
  "block.minecraft.light_gray_terracotta": "terracota gris clar",
  "block.minecraft.cyan_terracotta": "terracota cian",
  "block.minecraft.purple_terracotta": "terracota morada",
  "block.minecraft.blue_terracotta": "terracota blava",
  "block.minecraft.brown_terracotta": "terracota marró",
  "block.minecraft.green_terracotta": "terracota verda",
  "block.minecraft.red_terracotta": "terracota vermella",
  "block.minecraft.black_terracotta": "terracota negra",
  "block.minecraft.barrier": "barrera",
  "block.minecraft.iron_trapdoor": "trapa de ferro",
  "block.minecraft.hay_block": "bala de fenc",
  "block.minecraft.white_carpet": "catifa blanca",
  "block.minecraft.orange_carpet": "catifa taronja",
  "block.minecraft.magenta_carpet": "catifa magenta",
  "block.minecraft.light_blue_carpet": "catifa blau cel",
  "block.minecraft.yellow_carpet": "catifa groga",
  "block.minecraft.lime_carpet": "catifa llima",
  "block.minecraft.pink_carpet": "catifa rosa",
  "block.minecraft.gray_carpet": "catifa grisa",
  "block.minecraft.light_gray_carpet": "catifa gris clar",
  "block.minecraft.cyan_carpet": "catifa cian",
  "block.minecraft.purple_carpet": "catifa lila",
  "block.minecraft.blue_carpet": "catifa blava",
  "block.minecraft.brown_carpet": "catifa marró",
  "block.minecraft.green_carpet": "catifa verda",
  "block.minecraft.red_carpet": "catifa vermella",
  "block.minecraft.black_carpet": "catifa negra",
  "block.minecraft.terracotta": "terracota",
  "block.minecraft.coal_block": "bloc de carbó",
  "block.minecraft.packed_ice": "gel compactat",
  "block.minecraft.acacia_stairs": "escales d'acàcia",
  "block.minecraft.dark_oak_stairs": "escales de pomer fosc",
  "block.minecraft.slime_block": "bloc de llim",
  "block.minecraft.grass_path": "camí d'herba",
  "block.minecraft.sunflower": "gira-sol",
  "block.minecraft.lilac": "lilà",
  "block.minecraft.rose_bush": "roser",
  "block.minecraft.peony": "peònia",
  "block.minecraft.tall_grass": "herba alta",
  "block.minecraft.large_fern": "falguera gran",
  "block.minecraft.white_stained_glass": "vidre tenyit de blanc",
  "block.minecraft.orange_stained_glass": "vidre tenyit de taronja",
  "block.minecraft.magenta_stained_glass": "vidre tenyit de magenta",
  "block.minecraft.light_blue_stained_glass": "vidre tenyit de blau cel",
  "block.minecraft.yellow_stained_glass": "vidre tenyit de groc",
  "block.minecraft.lime_stained_glass": "vidre tenyit de llima",
  "block.minecraft.pink_stained_glass": "vidre tenyit de rosa",
  "block.minecraft.gray_stained_glass": "vidre tenyit de gris",
  "block.minecraft.light_gray_stained_glass": "vidre tenyit de gris clar",
  "block.minecraft.cyan_stained_glass": "vidre tenyit de cian",
  "block.minecraft.purple_stained_glass": "vidre tenyit de lila",
  "block.minecraft.blue_stained_glass": "vidre tenyit de blau",
  "block.minecraft.brown_stained_glass": "vidre tenyit de marró",
  "block.minecraft.green_stained_glass": "vidre tenyit de verd",
  "block.minecraft.red_stained_glass": "vidre tenyit de vermell",
  "block.minecraft.black_stained_glass": "vidre tenyit de negre",
  "block.minecraft.white_stained_glass_pane": "panell de vidre tenyit de blanc",
  "block.minecraft.orange_stained_glass_pane": "panell de vidre tenyit de taronja",
  "block.minecraft.magenta_stained_glass_pane": "panell de vidre tenyit de magenta",
  "block.minecraft.light_blue_stained_glass_pane": "panell de vidre tenyit de blau cel",
  "block.minecraft.yellow_stained_glass_pane": "panell de vidre tenyit de groc",
  "block.minecraft.lime_stained_glass_pane": "panell de vidre tenyit de llima",
  "block.minecraft.pink_stained_glass_pane": "panell de vidre tenyit de rosa",
  "block.minecraft.gray_stained_glass_pane": "panell de vidre tenyit de gris",
  "block.minecraft.light_gray_stained_glass_pane": "panell de vidre tenyit de gris clar",
  "block.minecraft.cyan_stained_glass_pane": "panell de vidre tenyit de cian",
  "block.minecraft.purple_stained_glass_pane": "panell de vidre tenyit de lila",
  "block.minecraft.blue_stained_glass_pane": "panell de vidre tenyit de blau",
  "block.minecraft.brown_stained_glass_pane": "panell de vidre tenyit de marró",
  "block.minecraft.green_stained_glass_pane": "panell de vidre tenyit de verd",
  "block.minecraft.red_stained_glass_pane": "panell de vidre tenyit de vermell",
  "block.minecraft.black_stained_glass_pane": "panell de vidre tenyit de negre",
  "block.minecraft.prismarine": "prismarina",
  "block.minecraft.prismarine_bricks": "maons de prismarina",
  "block.minecraft.dark_prismarine": "prismarina fosca",
  "block.minecraft.prismarine_stairs": "escales de prismarina",
  "block.minecraft.prismarine_brick_stairs": "escales de maons de prismarina",
  "block.minecraft.dark_prismarine_stairs": "escales de prismarina fosca",
  "block.minecraft.sea_lantern": "llanterna marina",
  "block.minecraft.red_sandstone": "roca sorrenca vermella",
  "block.minecraft.chiseled_red_sandstone": "roca sorrenca cisellada",
  "block.minecraft.cut_red_sandstone": "roca sorrenca vermella tallada",
  "block.minecraft.red_sandstone_stairs": "escales de roca sorrenca vermella",
  "block.minecraft.repeating_command_block": "bloc de comandaments repetitiu",
  "block.minecraft.chain_command_block": "bloc de comandaments en cadena",
  "block.minecraft.magma_block": "bloc de magma",
  "block.minecraft.nether_wart_block": "bloc de berrugues del nether",
  "block.minecraft.warped_wart_block": "bloc de berrugues guerxes",
  "block.minecraft.red_nether_bricks": "maons del nether vermells",
  "block.minecraft.bone_block": "bloc d'os",
  "block.minecraft.structure_void": "buit estructural",
  "block.minecraft.observer": "observador",
  "block.minecraft.shulker_box": "caixa de shulker",
  "block.minecraft.white_shulker_box": "caixa de shulker blanca",
  "block.minecraft.orange_shulker_box": "caixa de shulker taronja",
  "block.minecraft.magenta_shulker_box": "caixa de shulker magenta",
  "block.minecraft.light_blue_shulker_box": "caixa de shulker blau cel",
  "block.minecraft.yellow_shulker_box": "caixa de shulker groga",
  "block.minecraft.lime_shulker_box": "caixa de shulker llima",
  "block.minecraft.pink_shulker_box": "caixa de shulker rosa",
  "block.minecraft.gray_shulker_box": "caixa de shulker grisa",
  "block.minecraft.light_gray_shulker_box": "caixa de shulker gris clar",
  "block.minecraft.cyan_shulker_box": "caixa de shulker cian",
  "block.minecraft.purple_shulker_box": "caixa de shulker lila",
  "block.minecraft.blue_shulker_box": "caixa de shulker blava",
  "block.minecraft.brown_shulker_box": "caixa de shulker marró",
  "block.minecraft.green_shulker_box": "caixa de shulker verda",
  "block.minecraft.red_shulker_box": "caixa de shulker vermella",
  "block.minecraft.black_shulker_box": "caixa de shulker negra",
  "block.minecraft.white_glazed_terracotta": "rajola blanca",
  "block.minecraft.orange_glazed_terracotta": "rajola taronja",
  "block.minecraft.magenta_glazed_terracotta": "rajola magenta",
  "block.minecraft.light_blue_glazed_terracotta": "rajola blau cel",
  "block.minecraft.yellow_glazed_terracotta": "rajola groga",
  "block.minecraft.lime_glazed_terracotta": "rajola llima",
  "block.minecraft.pink_glazed_terracotta": "rajola rosa",
  "block.minecraft.gray_glazed_terracotta": "rajola gris",
  "block.minecraft.light_gray_glazed_terracotta": "rajola gris clar",
  "block.minecraft.cyan_glazed_terracotta": "rajola cian",
  "block.minecraft.purple_glazed_terracotta": "rajola morada",
  "block.minecraft.blue_glazed_terracotta": "rajola blava",
  "block.minecraft.brown_glazed_terracotta": "rajola marró",
  "block.minecraft.green_glazed_terracotta": "rajola verda",
  "block.minecraft.red_glazed_terracotta": "rajola vermella",
  "block.minecraft.black_glazed_terracotta": "rajola negra",
  "block.minecraft.white_concrete": "formigó blanc",
  "block.minecraft.orange_concrete": "formigó taronja",
  "block.minecraft.magenta_concrete": "formigó magenta",
  "block.minecraft.light_blue_concrete": "formigó blau cel",
  "block.minecraft.yellow_concrete": "formigó groc",
  "block.minecraft.lime_concrete": "formigó llima",
  "block.minecraft.pink_concrete": "formigó rosa",
  "block.minecraft.gray_concrete": "formigó gris",
  "block.minecraft.light_gray_concrete": "formigó gris clar",
  "block.minecraft.cyan_concrete": "formigó cian",
  "block.minecraft.purple_concrete": "formigó morat",
  "block.minecraft.blue_concrete": "formigó blau",
  "block.minecraft.brown_concrete": "formigó marró",
  "block.minecraft.green_concrete": "formigó verd",
  "block.minecraft.red_concrete": "formigó vermell",
  "block.minecraft.black_concrete": "formigó negre",
  "block.minecraft.white_concrete_powder": "pols de formigó blanc",
  "block.minecraft.orange_concrete_powder": "pols de formigó taronja",
  "block.minecraft.magenta_concrete_powder": "pols de formigó magenta",
  "block.minecraft.light_blue_concrete_powder": "pols de formigó blau cel",
  "block.minecraft.yellow_concrete_powder": "pols de formigó groc",
  "block.minecraft.lime_concrete_powder": "pols de formigó llima",
  "block.minecraft.pink_concrete_powder": "pols de formigó rosa",
  "block.minecraft.gray_concrete_powder": "pols de formigó verd",
  "block.minecraft.light_gray_concrete_powder": "pols de formigó gris clar",
  "block.minecraft.cyan_concrete_powder": "pols de formigó cian",
  "block.minecraft.purple_concrete_powder": "pols de formigó morat",
  "block.minecraft.blue_concrete_powder": "pols de formigó blau",
  "block.minecraft.brown_concrete_powder": "pols de formigó marró",
  "block.minecraft.green_concrete_powder": "pols de formigó verd",
  "block.minecraft.red_concrete_powder": "pols de formigó vermell",
  "block.minecraft.black_concrete_powder": "pols de formigó negre",
  "block.minecraft.turtle_egg": "ou de tortuga",
  "block.minecraft.dead_tube_coral_block": "bloc de corall de tub mort",
  "block.minecraft.dead_brain_coral_block": "bloc de corall de cervell mort",
  "block.minecraft.dead_bubble_coral_block": "bloc de corall de bombolla mort",
  "block.minecraft.dead_fire_coral_block": "bloc de corall de foc mort",
  "block.minecraft.dead_horn_coral_block": "bloc de corall de banya mort",
  "block.minecraft.tube_coral_block": "bloc de corall de tub",
  "block.minecraft.brain_coral_block": "bloc de corall de cervell",
  "block.minecraft.bubble_coral_block": "bloc de corall de bombolla",
  "block.minecraft.fire_coral_block": "bloc de corall de foc",
  "block.minecraft.horn_coral_block": "bloc de corall de banya",
  "block.minecraft.tube_coral": "corall de tub",
  "block.minecraft.brain_coral": "corall de cervell",
  "block.minecraft.bubble_coral": "corall de bombolla",
  "block.minecraft.fire_coral": "corall de foc",
  "block.minecraft.horn_coral": "corall de banya",
  "block.minecraft.dead_brain_coral": "corall de cervell mort",
  "block.minecraft.dead_bubble_coral": "corall de bombolla mort",
  "block.minecraft.dead_fire_coral": "corall de foc mort",
  "block.minecraft.dead_horn_coral": "corall de banya mort",
  "block.minecraft.dead_tube_coral": "corall de tub mort",
  "block.minecraft.tube_coral_fan": "gorgònia de tub",
  "block.minecraft.brain_coral_fan": "gorgònia de cervell",
  "block.minecraft.bubble_coral_fan": "gorgònia de bombolla",
  "block.minecraft.fire_coral_fan": "gorgònia de foc",
  "block.minecraft.horn_coral_fan": "gorgònia de banya",
  "block.minecraft.dead_tube_coral_fan": "gorgònia de tub morta",
  "block.minecraft.dead_brain_coral_fan": "gorgònia de cervell morta",
  "block.minecraft.dead_bubble_coral_fan": "gorgònia de bombolla morta",
  "block.minecraft.dead_fire_coral_fan": "gorgònia de foc morta",
  "block.minecraft.dead_horn_coral_fan": "gorgònia de banya morta",
  "block.minecraft.blue_ice": "gel blau",
  "block.minecraft.conduit": "canalitzador",
  "block.minecraft.polished_granite_stairs": "escales de granit polit",
  "block.minecraft.smooth_red_sandstone_stairs": "escales de roca sorrenca vermella llisa",
  "block.minecraft.mossy_stone_brick_stairs": "escales de maons de roca amb molsa",
  "block.minecraft.polished_diorite_stairs": "escales de diorita polida",
  "block.minecraft.mossy_cobblestone_stairs": "escales de pedra amb molsa",
  "block.minecraft.end_stone_brick_stairs": "escales de maons de roca d'ender",
  "block.minecraft.stone_stairs": "escales de roca",
  "block.minecraft.smooth_sandstone_stairs": "escales de roca sorrenca llisa",
  "block.minecraft.smooth_quartz_stairs": "escales de quars llis",
  "block.minecraft.granite_stairs": "escales de granit",
  "block.minecraft.andesite_stairs": "escales d'andesita",
  "block.minecraft.red_nether_brick_stairs": "escales de maons del nether vermells",
  "block.minecraft.polished_andesite_stairs": "escales d'andesita polida",
  "block.minecraft.diorite_stairs": "escales de diorita",
  "block.minecraft.polished_granite_slab": "llosa de granit polit",
  "block.minecraft.smooth_red_sandstone_slab": "llosa de roca sorrenca vermella llisa",
  "block.minecraft.mossy_stone_brick_slab": "llosa de maons de roca amb molsa",
  "block.minecraft.polished_diorite_slab": "llosa de diorita polida",
  "block.minecraft.mossy_cobblestone_slab": "llosa de pedra amb molsa",
  "block.minecraft.end_stone_brick_slab": "llosa de maons de roca d'ender",
  "block.minecraft.smooth_sandstone_slab": "llosa de roca sorrenca llisa",
  "block.minecraft.smooth_quartz_slab": "llosa de quars llis",
  "block.minecraft.granite_slab": "llosa de granit",
  "block.minecraft.andesite_slab": "llosa d'andesita",
  "block.minecraft.red_nether_brick_slab": "llosa de maons del nether vermells",
  "block.minecraft.polished_andesite_slab": "llosa d'andesita polida",
  "block.minecraft.diorite_slab": "llosa de diorita",
  "block.minecraft.scaffolding": "bastida",
  "block.minecraft.iron_door": "porta de ferro",
  "block.minecraft.oak_door": "porta de pomer",
  "block.minecraft.spruce_door": "porta de pi",
  "block.minecraft.birch_door": "porta de fusta de bedoll",
  "block.minecraft.jungle_door": "porta de jungla",
  "block.minecraft.acacia_door": "porta d'acàcia",
  "block.minecraft.dark_oak_door": "porta de pomer fosc",
  "block.minecraft.crimson_door": "porta carmesina",
  "block.minecraft.warped_door": "porta guerxa",
  "block.minecraft.repeater": "repetidor",
  "block.minecraft.comparator": "comparador",
  "block.minecraft.structure_block": "bloc estructural",
  "block.minecraft.jigsaw": "bloc trencaclosques",
  "item.minecraft.turtle_helmet": "closca de tortuga□□al cap:□+2 armadura",
  "item.minecraft.scute": "escata de tortuga",
  "item.minecraft.iron_shovel": "pala de ferro□□a la mà principal:□+3.5 dany per atac□-3 velocitat d'atac",
  "item.minecraft.iron_pickaxe": "pic de ferro□□a la mà principal:□+3 dany per atac□-2.8 velocitat d'atac",
  "item.minecraft.iron_axe": "destral de ferro□□a la mà principal:□+8 dany per atac□-3.1 velocitat d'atac",
  "item.minecraft.flint_and_steel": "sílex i acer",
  "item.minecraft.apple": "poma",
  "item.minecraft.bow": "arc",
  "item.minecraft.arrow": "fletxa",
  "item.minecraft.coal": "carbó",
  "item.minecraft.charcoal": "carbó vegetal",
  "item.minecraft.diamond": "diamant",
  "item.minecraft.iron_ingot": "lingot de ferro",
  "item.minecraft.gold_ingot": "lingot d'or",
  "item.minecraft.netherite_ingot": "lingot de netherita",
  "item.minecraft.netherite_scrap": "ferralla de netherita",
  "item.minecraft.iron_sword": "espasa de ferro□□a la mà principal:□+5 dany per atac□-2.4 velocitat d'atac",
  "item.minecraft.wooden_sword": "espasa de fusta□□a la mà principal:□+3 dany per atac□-2.4 velocitat d'atac",
  "item.minecraft.wooden_shovel": "pala de fusta□□a la mà principal:□+1.5 dany per atac□-3 velocitat d'atac",
  "item.minecraft.wooden_pickaxe": "pic de fusta□□a la mà principal:□+1 dany per atac□-2.8 velocitat d'atac",
  "item.minecraft.wooden_axe": "destral de fusta□□a la mà principal:□+6 dany per atac□-3.2 velocitat d'atac",
  "item.minecraft.stone_sword": "espasa de pedra□□a la mà principal:□+4 dany per atac□-2.4 velocitat d'atac",
  "item.minecraft.stone_shovel": "pala de pedra□□a la mà principal:□+2.5 dany per atac□-3 velocitat d'atac",
  "item.minecraft.stone_pickaxe": "pic de pedra□□a la mà principal:□+2 dany per atac□-2.8 velocitat d'atac",
  "item.minecraft.stone_axe": "destral de pedra□□a la mà principal:□+8 dany per atac□-3.2 velocitat d'atac",
  "item.minecraft.diamond_sword": "espasa de diamant□□a la mà principal:□+6 dany per atac□-2.4 velocitat d'atac",
  "item.minecraft.diamond_shovel": "pala de diamant□□a la mà principal:□+4.5 dany per atac□-3 velocitat d'atac",
  "item.minecraft.diamond_pickaxe": "pic de diamant□□a la mà principal:□+4 dany per atac□-2.8 velocitat d'atac",
  "item.minecraft.diamond_axe": "destral de diamant□□a la mà principal:□+8 dany per atac□-3 velocitat d'atac",
  "item.minecraft.stick": "pal",
  "item.minecraft.bowl": "bol",
  "item.minecraft.mushroom_stew": "estofat de bolets",
  "item.minecraft.golden_sword": "espasa d'or□□a la mà principal:□+3 dany per atac□-2.4 velocitat d'atac",
  "item.minecraft.golden_shovel": "pala d'or□□a la mà principal:□+1.5 dany per atac□-3 velocitat d'atac",
  "item.minecraft.golden_pickaxe": "pic d'or□□a la mà principal:□+1 dany per atac□-2.8 velocitat d'atac",
  "item.minecraft.golden_axe": "destral d'or□□a la mà principal:□+6 dany per atac□-3 velocitat d'atac",
  "item.minecraft.netherite_sword": "espasa de netherita□□a la mà principal:□+7 dany per atac□-2.4 velocitat d'atac",
  "item.minecraft.netherite_shovel": "pala de netherita□□a la mà principal:□+5.5 dany per atac□-3 velocitat d'atac",
  "item.minecraft.netherite_pickaxe": "pic de netherita□□a la mà principal:□+5 dany per atac□-2.8 velocitat d'atac",
  "item.minecraft.netherite_axe": "destral de netherita□□a la mà principal:□+9 dany per atac□-3 velocitat d'atac",
  "item.minecraft.string": "fil",
  "item.minecraft.feather": "ploma",
  "item.minecraft.gunpowder": "pólvora",
  "item.minecraft.wooden_hoe": "aixada de fusta□□a la mà principal:□-3 velocitat d'atac",
  "item.minecraft.stone_hoe": "aixada de pedra□□a la mà principal:□-2 velocitat d'atac",
  "item.minecraft.iron_hoe": "aixada de ferro□□a la mà principal:□-1 velocitat d'atac",
  "item.minecraft.diamond_hoe": "aixada de diamant□□a la mà principal:",
  "item.minecraft.golden_hoe": "aixada d'or□□a la mà principal:□-3 velocitat d'atac",
  "item.minecraft.netherite_hoe": "aixada de netherita□□a la mà principal:",
  "item.minecraft.wheat_seeds": "llavors de blat",
  "item.minecraft.wheat": "blat",
  "item.minecraft.bread": "pa",
  "item.minecraft.leather_helmet": "casc de cuir□□al cap:□+1 armadura",
  "item.minecraft.leather_chestplate": "túnica de cuir□□al cos:□+3 armadura",
  "item.minecraft.leather_leggings": "pantalons de cuir□□a les cames:□+2 armadura",
  "item.minecraft.leather_boots": "botes de cuir□□als peus:□+1 armadura",
  "item.minecraft.chainmail_helmet": "casc de cota de malla□□al cap:□+2 armadura",
  "item.minecraft.chainmail_chestplate": "cuirassa de cota de malla□□al cos:□+5 armadura",
  "item.minecraft.chainmail_leggings": "pantalons de cota de malla□□a les cames:□+4 armadura",
  "item.minecraft.chainmail_boots": "botes de cota de malla□□als peus:□+1 armadura",
  "item.minecraft.iron_helmet": "casc de ferro□□al cap:□+2 armadura",
  "item.minecraft.iron_chestplate": "cuirassa de ferro□□al cos:□+6 armadura",
  "item.minecraft.iron_leggings": "malles de ferro□□a les cames:□+5 armadura",
  "item.minecraft.iron_boots": "botes de ferro□□als peus:□+2 armadura",
  "item.minecraft.diamond_helmet": "casc de diamant□□al cap:□+3 armadura□+2 duresa de l'armadura",
  "item.minecraft.diamond_chestplate": "cuirassa de diamant□□al cos:□+8 armadura□+2 duresa de l'armadura",
  "item.minecraft.diamond_leggings": "malles de diamant□□a les cames:□+6 armadura□+2 duresa de l'armadura",
  "item.minecraft.diamond_boots": "botes de diamant□□als peus:□+3 armadura□+2 duresa de l'armadura",
  "item.minecraft.golden_helmet": "casc d'or□□al cap:□+2 armadura",
  "item.minecraft.golden_chestplate": "cuirassa d'or□□al cos:□+5 armadura",
  "item.minecraft.golden_leggings": "malles d'or□□a les cames:□+3 armadura",
  "item.minecraft.golden_boots": "botes d'or□□als peus:□+1 armadura",
  "item.minecraft.netherite_helmet": "casc de netherita□□al cap:□+3 armadura□+3 duresa de l'armadura□+1 resistència al retrocés",
  "item.minecraft.netherite_chestplate": "cuirassa de netherita□□al cos:□+8 armadura□+3 duresa de l'armadura□+1 resistència al retrocés",
  "item.minecraft.netherite_leggings": "malles de netherita□□a les cames:□+6 armadura□+3 duresa de l'armadura□+1 resistència al retrocés",
  "item.minecraft.netherite_boots": "botes de netherita□□als peus:□+3 armadura□+3 duresa de l'armadura□+1 resistència al retrocés",
  "item.minecraft.flint": "sílex",
  "item.minecraft.porkchop": "carn de porc crua",
  "item.minecraft.cooked_porkchop": "carn de porc cuita",
  "item.minecraft.painting": "quadre",
  "item.minecraft.golden_apple": "poma d'or",
  "item.minecraft.enchanted_golden_apple": "poma daurada encantada",
  "block.minecraft.oak_sign": "cartell de pomer",
  "block.minecraft.spruce_sign": "cartell de pi",
  "block.minecraft.birch_sign": "cartell de bedoll",
  "block.minecraft.jungle_sign": "cartell de jungla",
  "block.minecraft.acacia_sign": "cartell d'acàcia",
  "block.minecraft.dark_oak_sign": "cartell de pomer fosc",
  "block.minecraft.crimson_sign": "cartell carmesí",
  "block.minecraft.warped_sign": "cartell guerxo",
  "item.minecraft.bucket": "galleda",
  "item.minecraft.water_bucket": "galleda d'aigua",
  "item.minecraft.lava_bucket": "galleda de lava",
  "item.minecraft.minecart": "vagoneta",
  "item.minecraft.saddle": "sella de muntar",
  "item.minecraft.redstone": "pols de redstone",
  "item.minecraft.snowball": "bola de neu",
  "item.minecraft.oak_boat": "barca de pomer",
  "item.minecraft.leather": "cuir",
  "item.minecraft.milk_bucket": "galleda amb llet",
  "item.minecraft.pufferfish_bucket": "galleda amb peix globus",
  "item.minecraft.salmon_bucket": "galleda amb salmó",
  "item.minecraft.cod_bucket": "galleda amb bacallà",
  "item.minecraft.tropical_fish_bucket": "galleda amb peix tropical",
  "item.minecraft.brick": "maó",
  "item.minecraft.clay_ball": "bola d'argila",
  "block.minecraft.dried_kelp_block": "bloc d'algues seques",
  "item.minecraft.paper": "paper",
  "item.minecraft.book": "llibre",
  "item.minecraft.slime_ball": "bola de llim",
  "item.minecraft.chest_minecart": "vagoneta amb cofre",
  "item.minecraft.furnace_minecart": "vagoneta amb forn",
  "item.minecraft.egg": "ou",
  "item.minecraft.compass": "brúixola",
  "item.minecraft.fishing_rod": "canya de pescar",
  "item.minecraft.clock": "rellotge",
  "item.minecraft.glowstone_dust": "pols de roca brillant",
  "item.minecraft.cod": "bacallà cru",
  "item.minecraft.salmon": "salmó cru",
  "item.minecraft.tropical_fish": "peix tropical",
  "item.minecraft.pufferfish": "peix globus",
  "item.minecraft.cooked_cod": "bacallà cuit",
  "item.minecraft.cooked_salmon": "salmó cuit",
  "item.minecraft.ink_sac": "sac de tinta",
  "item.minecraft.red_dye": "tint vermell",
  "item.minecraft.green_dye": "tint verd",
  "item.minecraft.cocoa_beans": "grans de cacau",
  "item.minecraft.lapis_lazuli": "lapislàtzuli",
  "item.minecraft.purple_dye": "tint lila",
  "item.minecraft.cyan_dye": "tint cian",
  "item.minecraft.light_gray_dye": "tint gris clar",
  "item.minecraft.gray_dye": "tint gris",
  "item.minecraft.pink_dye": "tint rosa",
  "item.minecraft.lime_dye": "tint llima",
  "item.minecraft.yellow_dye": "tint groc",
  "item.minecraft.light_blue_dye": "tint blau clar",
  "item.minecraft.magenta_dye": "tint magenta",
  "item.minecraft.orange_dye": "tint taronja",
  "item.minecraft.bone_meal": "farina d'ossos",
  "item.minecraft.blue_dye": "tint blau",
  "item.minecraft.brown_dye": "tint marró",
  "item.minecraft.black_dye": "tint negre",
  "item.minecraft.white_dye": "tint blanc",
  "item.minecraft.bone": "os",
  "item.minecraft.sugar": "sucre",
  "block.minecraft.cake": "pastís",
  "block.minecraft.white_bed": "llit blanc",
  "block.minecraft.orange_bed": "llit taronja",
  "block.minecraft.magenta_bed": "llit magenta",
  "block.minecraft.light_blue_bed": "llit blau cel",
  "block.minecraft.yellow_bed": "llit groc",
  "block.minecraft.lime_bed": "llit llima",
  "block.minecraft.pink_bed": "llit rosa",
  "block.minecraft.gray_bed": "llit gris",
  "block.minecraft.light_gray_bed": "llit gris clar",
  "block.minecraft.cyan_bed": "llit cian",
  "block.minecraft.purple_bed": "llit lila",
  "block.minecraft.blue_bed": "llit blau",
  "block.minecraft.brown_bed": "llit marró",
  "block.minecraft.green_bed": "llit verd",
  "block.minecraft.red_bed": "llit vermell",
  "block.minecraft.black_bed": "llit negre",
  "item.minecraft.cookie": "galeta",
  "item.minecraft.filled_map": "mapa□#0",
  "item.minecraft.shears": "tisores d'esquilar",
  "item.minecraft.melon_slice": "tallada de síndria",
  "item.minecraft.dried_kelp": "algues seques",
  "item.minecraft.pumpkin_seeds": "llavors de carbassa",
  "item.minecraft.melon_seeds": "llavors de síndria",
  "item.minecraft.beef": "bistec cru",
  "item.minecraft.cooked_beef": "bistec",
  "item.minecraft.chicken": "carn de pollastre",
  "item.minecraft.cooked_chicken": "pollastre rostit",
  "item.minecraft.rotten_flesh": "carn podrida",
  "item.minecraft.ender_pearl": "perla d'ender",
  "item.minecraft.blaze_rod": "vara flamejant",
  "item.minecraft.ghast_tear": "llàgrima de ghast",
  "item.minecraft.gold_nugget": "grànul d'or",
  "item.minecraft.nether_wart": "berruga del nether",
  "item.minecraft.potion": "poció impossible d'elaborar□sense efectes",
  "item.minecraft.glass_bottle": "ampolla de vidre",
  "item.minecraft.spider_eye": "ull d'aranya",
  "item.minecraft.fermented_spider_eye": "ull d'aranya fermentat",
  "item.minecraft.blaze_powder": "pols de foc",
  "item.minecraft.magma_cream": "crema de magma",
  "block.minecraft.brewing_stand": "altar de pocions",
  "block.minecraft.cauldron": "calderó",
  "item.minecraft.ender_eye": "ull d'ender",
  "item.minecraft.glistering_melon_slice": "tallada de síndria daurada",
  "item.minecraft.bat_spawn_egg": "generar ratpenat",
  "item.minecraft.bee_spawn_egg": "generar abella",
  "item.minecraft.blaze_spawn_egg": "generar esperit del foc",
  "item.minecraft.cat_spawn_egg": "generar gat",
  "item.minecraft.cave_spider_spawn_egg": "generar aranya de cova",
  "item.minecraft.chicken_spawn_egg": "generar pollastre",
  "item.minecraft.cod_spawn_egg": "generar bacallà",
  "item.minecraft.cow_spawn_egg": "generar vaca",
  "item.minecraft.creeper_spawn_egg": "generar creeper",
  "item.minecraft.dolphin_spawn_egg": "generar dofí",
  "item.minecraft.donkey_spawn_egg": "generar ruc",
  "item.minecraft.drowned_spawn_egg": "generar ofegat",
  "item.minecraft.elder_guardian_spawn_egg": "generar guardià ancià",
  "item.minecraft.enderman_spawn_egg": "generar home d'ender",
  "item.minecraft.endermite_spawn_egg": "generar peixet d'ender",
  "item.minecraft.evoker_spawn_egg": "generar invocador",
  "item.minecraft.fox_spawn_egg": "generar guineu",
  "item.minecraft.ghast_spawn_egg": "generar ghast",
  "item.minecraft.guardian_spawn_egg": "generar guardià",
  "item.minecraft.hoglin_spawn_egg": "generar hoglin",
  "item.minecraft.horse_spawn_egg": "generar cavall",
  "item.minecraft.husk_spawn_egg": "generar zombi ressec",
  "item.minecraft.llama_spawn_egg": "generar llama",
  "item.minecraft.magma_cube_spawn_egg": "generar cub de magma",
  "item.minecraft.mooshroom_spawn_egg": "generar vaca amb bolets",
  "item.minecraft.mule_spawn_egg": "generar mula",
  "item.minecraft.ocelot_spawn_egg": "generar ocelot",
  "item.minecraft.panda_spawn_egg": "generar panda",
  "item.minecraft.parrot_spawn_egg": "generar lloro",
  "item.minecraft.phantom_spawn_egg": "generar fantasma",
  "item.minecraft.pig_spawn_egg": "generar porc",
  "item.minecraft.piglin_spawn_egg": "generar piglin",
  "item.minecraft.pillager_spawn_egg": "generar saquejador",
  "item.minecraft.polar_bear_spawn_egg": "generar ós polar",
  "item.minecraft.pufferfish_spawn_egg": "generar peix globus",
  "item.minecraft.rabbit_spawn_egg": "generar conill",
  "item.minecraft.ravager_spawn_egg": "generar devastador",
  "item.minecraft.salmon_spawn_egg": "generar salmó",
  "item.minecraft.sheep_spawn_egg": "generar ovella",
  "item.minecraft.shulker_spawn_egg": "generar shulker",
  "item.minecraft.silverfish_spawn_egg": "generar peixet de plata",
  "item.minecraft.skeleton_spawn_egg": "generar esquelet",
  "item.minecraft.skeleton_horse_spawn_egg": "generar cavall esquelètic",
  "item.minecraft.slime_spawn_egg": "generar llim",
  "item.minecraft.spider_spawn_egg": "generar aranya",
  "item.minecraft.squid_spawn_egg": "generar calamar",
  "item.minecraft.stray_spawn_egg": "generar esquelet extraviat",
  "item.minecraft.strider_spawn_egg": "generar caminant",
  "item.minecraft.trader_llama_spawn_egg": "generar llama ambulant",
  "item.minecraft.tropical_fish_spawn_egg": "generar peix tropical",
  "item.minecraft.turtle_spawn_egg": "generar tortuga",
  "item.minecraft.vex_spawn_egg": "generar esperit",
  "item.minecraft.villager_spawn_egg": "generar vilatà",
  "item.minecraft.vindicator_spawn_egg": "generar vindicador",
  "item.minecraft.wandering_trader_spawn_egg": "generar comerciant",
  "item.minecraft.witch_spawn_egg": "generar bruixa",
  "item.minecraft.wither_skeleton_spawn_egg": "generar esquelet wither",
  "item.minecraft.wolf_spawn_egg": "generar llop",
  "item.minecraft.zoglin_spawn_egg": "generar zoglin",
  "item.minecraft.zombie_spawn_egg": "generar zombi",
  "item.minecraft.zombie_horse_spawn_egg": "generar cavall zombi",
  "item.minecraft.zombie_villager_spawn_egg": "generar vilatà zombi",
  "item.minecraft.zombified_piglin_spawn_egg": "generar piglin zombificat",
  "item.minecraft.experience_bottle": "ampolla màgica",
  "item.minecraft.fire_charge": "càrrega de foc",
  "item.minecraft.writable_book": "llibre i tinter",
  "item.minecraft.written_book": "llibre escrit",
  "item.minecraft.emerald": "maragda",
  "item.minecraft.item_frame": "marc",
  "block.minecraft.flower_pot": "test",
  "item.minecraft.carrot": "pastanaga",
  "item.minecraft.potato": "patata",
  "item.minecraft.baked_potato": "patata cuita",
  "item.minecraft.poisonous_potato": "patata verinosa",
  "item.minecraft.map": "mapa en blanc",
  "item.minecraft.golden_carrot": "pastanaga daurada",
  "block.minecraft.skeleton_skull": "calavera d'esquelet",
  "block.minecraft.wither_skeleton_skull": "calavera d'esquelet wither",
  "block.minecraft.player_head": "cap de jugador",
  "block.minecraft.zombie_head": "cap de zombi",
  "block.minecraft.creeper_head": "cap de creeper",
  "block.minecraft.dragon_head": "cap de drac",
  "item.minecraft.carrot_on_a_stick": "canya amb pastanaga",
  "item.minecraft.warped_fungus_on_a_stick": "canya amb fong guerxo",
  "item.minecraft.nether_star": "estrella del nether",
  "item.minecraft.pumpkin_pie": "pastís de carbassa",
  "item.minecraft.firework_rocket": "focs artificials",
  "item.minecraft.firework_star": "estrella de focs artificials",
  "item.minecraft.enchanted_book": "llibre encantat",
  "item.minecraft.nether_brick": "maó del nether",
  "item.minecraft.quartz": "quars del nether",
  "item.minecraft.tnt_minecart": "vagoneta amb dinamita",
  "item.minecraft.hopper_minecart": "vagoneta amb tremuja",
  "item.minecraft.prismarine_shard": "fragment de prismarina",
  "item.minecraft.prismarine_crystals": "cristalls de prismarina",
  "item.minecraft.rabbit": "carn de conill crua",
  "item.minecraft.cooked_rabbit": "conill rostit",
  "item.minecraft.rabbit_stew": "estofat de conill",
  "item.minecraft.rabbit_foot": "pota de conill",
  "item.minecraft.rabbit_hide": "pell de conill",
  "item.minecraft.armor_stand": "maniquí",
  "item.minecraft.iron_horse_armor": "armadura de ferro per a cavalls",
  "item.minecraft.golden_horse_armor": "armadura d'or per a cavalls",
  "item.minecraft.diamond_horse_armor": "armadura de diamant per a cavalls",
  "item.minecraft.leather_horse_armor": "armadura de cuir per a cavalls",
  "item.minecraft.lead": "llaç",
  "item.minecraft.name_tag": "etiqueta de nom",
  "item.minecraft.command_block_minecart": "vagoneta amb bloc de comandaments",
  "item.minecraft.mutton": "carn d'ovella crua",
  "item.minecraft.cooked_mutton": "carn d'ovella cuita",
  "block.minecraft.white_banner": "estendard blanc",
  "block.minecraft.orange_banner": "estendard ataronjat",
  "block.minecraft.magenta_banner": "estendard magenta",
  "block.minecraft.light_blue_banner": "estendard blau cel",
  "block.minecraft.yellow_banner": "estendard d'or",
  "block.minecraft.lime_banner": "estendard llima",
  "block.minecraft.pink_banner": "estendard rosa",
  "block.minecraft.gray_banner": "estendard gris",
  "block.minecraft.light_gray_banner": "estendard d'argent",
  "block.minecraft.cyan_banner": "estendard cian",
  "block.minecraft.purple_banner": "estendard de porpra",
  "block.minecraft.blue_banner": "estendard d'atzur",
  "block.minecraft.brown_banner": "estendard marró",
  "block.minecraft.green_banner": "estendard de sinople",
  "block.minecraft.red_banner": "estendard de gules",
  "block.minecraft.black_banner": "estendard de sable",
  "item.minecraft.end_crystal": "cristall d'ender",
  "item.minecraft.chorus_fruit": "fruita de tornada",
  "item.minecraft.popped_chorus_fruit": "fruita de tornada cuita",
  "item.minecraft.beetroot": "remolatxa",
  "item.minecraft.beetroot_seeds": "llavors de remolatxa",
  "item.minecraft.beetroot_soup": "sopa de remolatxa",
  "item.minecraft.dragon_breath": "alè de drac",
  "item.minecraft.splash_potion": "poció llancívola impossible d'elaborar□sense efectes",
  "item.minecraft.spectral_arrow": "fletxa fantasmal",
  "item.minecraft.tipped_arrow": "fletxa amb efecte impossible d'elaborar□sense efectes",
  "item.minecraft.lingering_potion": "poció persistent impossible d'elaborar□sense efectes",
  "item.minecraft.shield": "escut",
  "item.minecraft.elytra": "èlitres",
  "item.minecraft.spruce_boat": "barca de pi",
  "item.minecraft.birch_boat": "barca de bedoll",
  "item.minecraft.jungle_boat": "barca de jungla",
  "item.minecraft.acacia_boat": "barca d'acàcia",
  "item.minecraft.dark_oak_boat": "barca de pomer fosc",
  "item.minecraft.totem_of_undying": "tòtem de l'immortalitat",
  "item.minecraft.shulker_shell": "closca de shulker",
  "item.minecraft.iron_nugget": "grànul de ferro",
  "item.minecraft.knowledge_book": "llibre del coneixement",
  "item.minecraft.debug_stick": "pal de proves",
  "item.minecraft.music_disc_13": "disc de música□c418 - 13",
  "item.minecraft.music_disc_cat": "disc de música□c418 - cat",
  "item.minecraft.music_disc_blocks": "disc de música□c418 - blocks",
  "item.minecraft.music_disc_chirp": "disc de música□c418 - chirp",
  "item.minecraft.music_disc_far": "disc de música□c418 - far",
  "item.minecraft.music_disc_mall": "disc de música□c418 - mall",
  "item.minecraft.music_disc_mellohi": "disc de música□c418 - mellohi",
  "item.minecraft.music_disc_stal": "disc de música□c418 - stal",
  "item.minecraft.music_disc_strad": "disc de música□c418 - strad",
  "item.minecraft.music_disc_ward": "disc de música□c418 - ward",
  "item.minecraft.music_disc_11": "disc de música□c418 - 11",
  "item.minecraft.music_disc_wait": "disc de música□c418 - wait",
  "item.minecraft.music_disc_pigstep": "disc de música□lena raine - pigstep",
  "item.minecraft.trident": "trident□□a la mà principal:□+8 dany per atac□-2.9 velocitat d'atac",
  "item.minecraft.phantom_membrane": "membrana fantasmal",
  "item.minecraft.nautilus_shell": "closca de nàutil",
  "item.minecraft.heart_of_the_sea": "cor del mar",
  "item.minecraft.crossbow": "ballesta",
  "item.minecraft.suspicious_stew": "estofat sospitós",
  "block.minecraft.loom": "teler",
  "item.minecraft.flower_banner_pattern": "patró de flor□estampat de flor",
  "item.minecraft.creeper_banner_pattern": "patró de creeper□estampat de creeper",
  "item.minecraft.skull_banner_pattern": "patró de calavera□estampat de calavera",
  "item.minecraft.mojang_banner_pattern": "patró de mojang□estampat de mojang",
  "item.minecraft.globe_banner_pattern": "patró de planeta□estampat de planeta",
  "item.minecraft.piglin_banner_pattern": "patró de piglin□morro",
  "block.minecraft.composter": "compostador",
  "block.minecraft.barrel": "barril",
  "block.minecraft.smoker": "fumador",
  "block.minecraft.blast_furnace": "alt forn",
  "block.minecraft.cartography_table": "taula de cartografia",
  "block.minecraft.fletching_table": "taula de fletxes",
  "block.minecraft.grindstone": "afiladora",
  "block.minecraft.lectern": "faristol",
  "block.minecraft.smithing_table": "taula de ferreria",
  "block.minecraft.stonecutter": "talla-roques",
  "block.minecraft.bell": "campana",
  "block.minecraft.lantern": "fanal",
  "block.minecraft.soul_lantern": "llanterna d'ànimes",
  "item.minecraft.sweet_berries": "baies dolces",
  "block.minecraft.campfire": "foguera",
  "block.minecraft.soul_campfire": "foguera d'ànimes",
  "block.minecraft.shroomlight": "girgolàmpada",
  "item.minecraft.honeycomb": "bresca",
  "block.minecraft.bee_nest": "rusc",
  "block.minecraft.beehive": "rusc fix",
  "item.minecraft.honey_bottle": "pot de mel",
  "block.minecraft.honey_block": "bloc de mel",
  "block.minecraft.honeycomb_block": "bloc de bresca",
  "block.minecraft.lodestone": "fita",
  "block.minecraft.netherite_block": "bloc de netherita",
  "block.minecraft.ancient_debris": "restes ancestrals",
  "block.minecraft.target": "blanc",
  "block.minecraft.crying_obsidian": "obsidiana plorosa",
  "block.minecraft.blackstone": "roca negra",
  "block.minecraft.blackstone_slab": "llosa de roca negra",
  "block.minecraft.blackstone_stairs": "escales de roca negra",
  "block.minecraft.gilded_blackstone": "roca negra lluent",
  "block.minecraft.polished_blackstone": "roca negra polida",
  "block.minecraft.polished_blackstone_slab": "llosa de roca negra polida",
  "block.minecraft.polished_blackstone_stairs": "escales de roca negra polida",
  "block.minecraft.chiseled_polished_blackstone": "roca negra polida cisellada",
  "block.minecraft.polished_blackstone_bricks": "maons de roca negra polida",
  "block.minecraft.polished_blackstone_brick_slab": "llosa de maons de roca negra polida",
  "block.minecraft.polished_blackstone_brick_stairs": "escales de maons de roca negra polida",
  "block.minecraft.cracked_polished_blackstone_bricks": "maons de roca negra polida esquerdats",
  "block.minecraft.respawn_anchor": "àncora de reaparició",
}
export const ca_es = items; 
